import { useQuery } from "@tanstack/react-query";
import { ContractorService } from "@/services/contractor.service";
import type { ContractorPayProfile } from "@/data/contractorPayProfile";

async function fetchPayProfiles(): Promise<ContractorPayProfile[]> {
  return ContractorService.fetchPayProfiles();
}

export function useReactQueryPayProfiles() {
  const {
    data: payProfiles = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: ["contractorPayProfiles"],
    queryFn: fetchPayProfiles,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return { payProfiles, loading: isLoading, error };
}
